module.exports = __webpack_public_path__ + "static/media/111.078281fd.jpg";